import React, { useContext } from 'react';
import { Link } from 'react-router';
import { isDraft } from '../../../shared/misc/utils';
import MainContext from '../../App/MainProvider/context';
import OperationContext from './context';
import Role from '../../../types/role';

interface QuickAccessItem {
  name: string;
  url: string;
  id: string;
  enabled: boolean;
  external?: boolean;
  viewerCanSee?: boolean;
}

const QuickAccessContent = () => {
  const { operation } = useContext(OperationContext);
  const { user, inSuperUserMode } = useContext(MainContext);

  const isDraftOp = isDraft(operation);
  const canEditMembers =
    user.roleCode === Role.GroupHead || user.roleCode === Role.HSO || inSuperUserMode();

  const getESSorInitialESRS = (isEspf: boolean) => {
    if (isEspf) {
      return {
        name: 'Initial ESRS',
        url: `/operations/${operation.number}/initial-esrs`,
        id: 'qa_initial_esrs',
        enabled: !isDraftOp,
      };
    }

    return {
      name: 'ESS',
      url: `/operations/${operation.number}/ess`,
      id: 'qa_ess',
      enabled: !isDraftOp,
    };
  };

  const getESMRorESRS = (isEspf: boolean) => {
    if (isEspf) {
      return {
        name: 'ESRS',
        url: `/operations/${operation.number}/esrs`,
        id: 'qa_esrs',
        enabled: !isDraftOp,
      };
    }

    return {
      name: 'ESMR',
      url: `/operations/${operation.number}/esmr`,
      id: 'qa_esmr',
      enabled: !isDraftOp,
    };
  };

  const getSR = (isEspf: boolean) => {
    if (isEspf) {
      return {
        name: 'Supervision Report',
        url: `/operations/${operation.number}/supervision-report-espf`,
        id: 'qa_sr_espf',
        enabled: !isDraftOp,
      };
    }

    return {
      name: 'Supervision Report',
      url: `/operations/${operation.number}/supervision-report`,
      id: 'qa_sr',
      enabled: !isDraftOp,
    };
  };

  const arrayLinks = [
    {
      name: 'Toolkit',
      url: `/operations/${operation.number}/toolkit`,
      id: 'qa_toolkit',
      enabled: !isDraftOp,
      viewerCanSee: true,
    },
    {
      name: 'ESRR',
      url: `/operations/${operation.number}/esrr`,
      id: 'qa_esrr',
      enabled: !isDraftOp,
      viewerCanSee: true,
    },
    getESSorInitialESRS(operation.isEspf),
    getESMRorESRS(operation.isEspf),
    getSR(operation.isEspf),
    {
      name: 'Action Plan',
      url: `/operations/${operation.number}/action-plan`,
      id: 'qa_actionplan',
      enabled: !isDraftOp,
    },
    {
      name: 'Loan Contract',
      url: `https://www.iadb.org/en/project/${operation.number}`,
      id: 'qa_loanContract',
      enabled: true,
      external: true,
    },
    {
      name: 'Team Members',
      url: `/operations/${operation.number}/members`,
      id: 'qa_members',
      enabled: !isDraftOp || canEditMembers,
    },
    {
      name: 'EzShare Site',
      url: `${operation.ezShareSiteUrl}/50%20Environmental%20and%20Social/Forms/All%20Documents.aspx`,
      id: 'qa_ezshare',
      enabled: true,
      external: true,
    },
  ];

  if (operation.miciCaseIds.length > 0) {
    arrayLinks.push({
      name: 'MICI',
      url: `/mici-cases${
        operation.miciCaseIds.length === 1 ? `/${operation.miciCaseIds[0]}` : ''
      }?operationNumber=${operation.number}`,
      id: 'qa_micicase',
      enabled: !isDraftOp,
      viewerCanSee: true,
    });
  }
  const renderLinks = (links: QuickAccessItem[]) => (
    <div className="list-links">
      {links.map((link) =>
        !link.external ? (
          <Link
            key={link.name}
            to={link.url}
            id={link.id}
            className="ml-0"
            style={{
              pointerEvents:
                link.enabled && !(user.roleCode === Role.Viewer && !link.viewerCanSee)
                  ? 'initial'
                  : 'none',
              color: user.roleCode === Role.Viewer && !link.viewerCanSee ? '#c4c4c4' : undefined,
            }}
          >
            <span>{link.name}</span>
          </Link>
        ) : (
          <a
            key={link.name}
            id={link.id}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-0"
            href={link.url}
          >
            <span>{link.name}</span>
          </a>
        )
      )}
    </div>
  );
  return <>{renderLinks(arrayLinks)}</>;
};

export default QuickAccessContent;
